import { gql } from "@apollo/client";

export const SEND_CONSENT_CODE = gql`
mutation CreateGmailAuth($authorizeCodeInput: ExchangeAuthorizeCodeInput!) {
  createGmailAuth(authorizeCodeInput: $authorizeCodeInput) {
  email
  name
  }
}
`

export const REMOVE_GMAIL_LINKED = gql`
mutation Mutation {
  deleteGmailAuth
}
`